import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'

import styles from './styles'

const HeaderButton = ({ onClick, classes, count, isActive, children }) => {
  return (
    <div
      onClick={onClick}
      className={classnames(classes.buttonWrapper, { 'active': isActive })}
    >
      {children}
      {count > 0 && <span className={classes.count}>{count}</span>}
    </div>
  )
}
export default injectStyles(styles)(HeaderButton)



// WEBPACK FOOTER //
// ./src/Components/Header/HeaderButton/index.js